/**
 * The canvas tarp's remote control.
 *
 * Owns: the single handle screens use to cover the picture and lift it again.
 * Must not: draw anything — `Tarp.vue` does, mounted once in `App.vue`, and
 * registers itself here. It lives above both the harbour and the battle,
 * because the screen that asks for it is gone before it opens.
 *
 * With no tarp mounted (a screen under test, or the dev routes) every call
 * resolves at once, so a caller never needs to know whether there is one.
 */
export interface TarpController {
  /** Cover the screen and pin up `name`; resolves once it is fully covered. */
  close(name: string): Promise<void>;
  /** Lift the tarp; resolves once it is gone. A no-op when it is not down. */
  open(): Promise<void>;
  /** Covered now, or on its way down. */
  isClosed(): boolean;
}

let controller: TarpController | null = null;

export function registerTarp(next: TarpController | null): void {
  controller = next;
}

export const tarp: TarpController = {
  close: (name) => controller?.close(name) ?? Promise.resolve(),
  open: () => controller?.open() ?? Promise.resolve(),
  isClosed: () => controller?.isClosed() ?? false,
};
